import { getProducts, getPublicProducts } from 'pricing-pages-lib/api/ProductsApi';
import { PRODUCTS } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchProductsRequestTypes = createRequestTypes(PRODUCTS);
export const FetchProductsActions = createRequestActions(FetchProductsRequestTypes);
export const fetchProducts = () => makeFetchRequest({
  requestActions: FetchProductsActions,
  fetch: getProducts
});
export const fetchPublicProducts = () => makeFetchRequest({
  requestActions: FetchProductsActions,
  fetch: getPublicProducts
});